// The kit Tag for the asset lifecycle words: operational status, derived charger status and
// inventory category. One place maps each to its hue so a list, a detail page and a picker
// cannot disagree. A neutral state (retired, raw) takes the neutral tone, not a hue.
import React from 'react';
import Tag from '../components/ui/Tag';
import {
  ChargerStatus, CHARGER_STATUS_LABELS, InventoryCategory, OperationalStatus, STATUS_LABELS,
} from './types';

const GREEN = '#86efac';
const AMBER = '#fcd34d';
const YELLOW = '#fde047';
const RED = '#fca5a5';
const BLUE = '#93c5fd';
const EMERALD = '#6ee7b7';
const SKY = '#7dd3fc';
const VIOLET = '#c4b5fd';

const STATUS_HEX: Record<OperationalStatus, string | undefined> = {
  ready: GREEN,
  building: AMBER,
  flagged: YELLOW,
  ooc: RED,
  checked_out: BLUE,
  retired: undefined,
};

const CHARGER_HEX: Record<ChargerStatus, string | undefined> = {
  assembly: AMBER,
  needs_repair: RED,
  purchased: GREEN,
  leased: EMERALD,
  home_base: SKY,
  traveling: VIOLET,
  retired: undefined,
};

const CATEGORY_HEX: Record<InventoryCategory, string | undefined> = {
  raw: undefined,
  sub_assembly: undefined,
  wip: AMBER,
  finished_good: EMERALD,
  cogs: SKY,
  retired: undefined,
};

interface TagSizeProps {
  size?: 'md' | 'sm';
  className?: string;
}

export const AssetStatusTag: React.FC<TagSizeProps & { status: OperationalStatus }> = ({ status, size = 'sm', className }) => (
  <Tag hex={STATUS_HEX[status]} size={size} className={className}>{STATUS_LABELS[status]}</Tag>
);

export const ChargerStatusTag: React.FC<TagSizeProps & { status: ChargerStatus }> = ({ status, size = 'sm', className }) => (
  <Tag hex={CHARGER_HEX[status]} size={size} className={className}>{CHARGER_STATUS_LABELS[status]}</Tag>
);

export const InventoryCategoryTag: React.FC<TagSizeProps & { category: InventoryCategory; label: string }> = ({ category, label, size = 'sm', className }) => (
  <Tag hex={CATEGORY_HEX[category]} size={size} className={className}>{label}</Tag>
);
